import { Routes } from '@angular/router';
import { WorkspaceDrawerBehaviorResolver } from '../layout/workspace-drawer-behavior-resolver';
import { routeData } from '../shared/route-helpers';
import { SampleManagementGuard } from './sample-management-guard';
import { SampleManagementLevelComponent } from './sample-management-level.component';
import { audienceRole, UserAudienceRoleGuard } from '../user';
import { PendingSampleRegistrationComponent } from './registration/pending-registration.component';
import { RegisteredSamplesComponent } from './registration/registered-samples.component';
import { ShipmentListComponent } from '../site-shipping-tool/shipment-list/shipment-list.component';
import { ProtocolShipmentListComponent } from '../site-shipping-tool/protocol-shipment-list/protocol-shipment-list.component';
import { CreateShipmentFormGuard } from '../site-shipping-tool/shipment-form/create-shipment/create-shipment-guard';
import { CreateShipmentComponent } from '../site-shipping-tool/shipment-form/create-shipment/create-shipment.component';
import { ResumeShipmentFormGuard } from '../site-shipping-tool/shipment-form/resume-shipment/resume-shipment-guard';
import { ResumeShipmentComponent } from '../site-shipping-tool/shipment-form/resume-shipment/resume-shipment.component';
import { ShipmentSummaryComponent } from '../site-shipping-tool/shipment-summary/shipment-summary.component';
import { SMWorkspaceLevelLayoutComponent } from './home/sm-workspace-level-layout.component';
import { SMNavigationComponent } from './home/navigation/sm-navigation.component';
import { SiteShippingLoaderComponent } from '../site-shipping-tool/site-shipping-loader';
import { RegisterSamplesComponent } from './register-samples/register-samples.component';
import { AccessionDetailsComponent } from './register-samples/accession-details/accession-details.component'; 
import { SubmittedShipmentListComponent } from '../site-shipping-tool/submitted-shipment-list/submitted-shipment-list.component';
import { EreqSmLandingPage } from './ereq-sample-registration/ereq-sm-landing-page/ereq-sm-landing-page.component';
import { EreqAccessionDetailsComponent } from './register-samples/accession-details/ereq-accession-details.component';

export const sampleManagementRoutes: Routes = [
    {
        path: `sample-management`,
        canActivate: [SampleManagementGuard],
        component: SampleManagementLevelComponent,
        resolve: {
            [routeData.drawerBehavior]: WorkspaceDrawerBehaviorResolver,
        },
        children: [
            {
                path: '',
                component: SMWorkspaceLevelLayoutComponent,
                children: [
                    {
                        path: 'pending/registration/list',
                        data: {
                            ...audienceRole('Investigator'),
                            title: 'Pending Registration'
                        },
                        component: PendingSampleRegistrationComponent
                    },
                    {
                        path: 'registered/samples/list',
                        data: {
                            ...audienceRole('Investigator'),
                            title: 'Registered Samples'
                        },
                        component: RegisteredSamplesComponent
                    },
                    {
                        path: 'sample/registration',
                        data: {
                            ...audienceRole('Investigator'),
                            title: 'Sample Registration'
                        },
                        component: AccessionDetailsComponent
                    },
                    {
                        path: ':type/sample/registration',
                        data: {
                            ...audienceRole('Investigator'),
                            title: 'Sample Registration'
                        },
                        component: RegisterSamplesComponent
                    },
                    {
                        path: 'register/:accession',
                        canActivate: [UserAudienceRoleGuard],
                        data: {
                            ...audienceRole('Investigator'),
                            title: 'Sample Registration'
                        },
                        component: EreqSmLandingPage,
                    },
                    {
                        path: 'ereq/sample/registration',
                        canActivate: [UserAudienceRoleGuard],
                        data: {
                            ...audienceRole('Investigator'),
                            title: 'Sample Registration'
                        },
                        component: EreqAccessionDetailsComponent,
                    },
                    {
                        path: 'shipment',
                        canActivate: [UserAudienceRoleGuard],
                        data: {
                            ...audienceRole('Investigator'),
                            title: 'Shipments'
                        },
                        component: SiteShippingLoaderComponent,
                        children: [
                            {
                                path: 'inProgressShipment',
                                data: {
                                    ...audienceRole('Investigator'),
                                    title: 'In-Progress Shipments'
                                },
                                component: ShipmentListComponent
                            },
                            {
                                path: 'submittedShipment',
                                data: {
                                    ...audienceRole('Investigator'),
                                    title: 'Submitted Shipments'
                                },
                                component: SubmittedShipmentListComponent
                            },
                            {
                                path: 'protocol-list',
                                canActivate: [UserAudienceRoleGuard],
                                data: {
                                    ...audienceRole('Investigator'),
                                    title: 'Samples by Protocol'
                                },
                                component: ProtocolShipmentListComponent
                            },
                            {
                                path: 'create',
                                canActivate: [UserAudienceRoleGuard, CreateShipmentFormGuard],
                                data: {
                                    ...audienceRole('Investigator'),
                                    title: 'Create Shipment'
                                },
                                canDeactivate: [CreateShipmentFormGuard],
                                component: CreateShipmentComponent,
                            },
                            {
                                path: 'resume/:id',
                                canActivate: [UserAudienceRoleGuard],
                                data: {
                                    ...audienceRole('Investigator'),
                                    title: 'Resume Shipment'
                                },
                                canDeactivate: [ResumeShipmentFormGuard],
                                component: ResumeShipmentComponent,
                            },
                            {
                                path: ':id/:type/summary',
                                canActivate: [UserAudienceRoleGuard],
                                data: {
                                    ...audienceRole('Investigator'),
                                    title: 'Shipment Summary'
                                },
                                component: ShipmentSummaryComponent
                            },
                        ]
                    },
                    
                    {
                        path: '',
                        component: SMNavigationComponent,
                        outlet: 'navigation'
                    },
                ]
            }
        ]
    }
];